import Base from './Base'

export default class Simple extends Base {
    type = 'simple';
        
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'type', 'parent', 'position', 'name', 'price', 'originalPrice', 'image', 'description', 'new', 'delete', 'show', 'highlight'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}